import uiRouter from 'angular-ui-router';
import vacationsAbsencesRoutingComponent from './vacationsAbsencesRouting.component';
import vacationsAbsencesRoutingService from './vacationsAbsencesRouting.service';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let vacationsAbsencesRoutingModule = angular.module('vacations-absences.routing', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.ROOT, {
        abstract: true,
        parent: STATES.MAIN_ROUTING,
        url: ROUTES.VACATIONS_ABSENCES.ROOT,
        component: 'vacationsAbsencesRouting',
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          moduleClosed: (StatusAppCheckers) => StatusAppCheckers.getClosedModules(),
        }
      });
  })

  .component('vacationsAbsencesRouting', vacationsAbsencesRoutingComponent)

  .service('vacationsAbsencesRoutingService', vacationsAbsencesRoutingService)

  .name;

export default vacationsAbsencesRoutingModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacationsAbsencesRouting/vacationsAbsencesRouting.js